import { SelectOptions } from '@spo/logic';
import { VpIcon } from '@vtmn-play/react';
import { MultiValueProps, OptionProps, components } from 'react-select';
import './customSelectInput.scss';

export const MoreSelectedBadge = ({
  items,
}: {
  items: (string | React.JSX.Element)[];
}) => {
  const title: string = items.filter((i) => typeof i === 'string').join(', ');
  return (
    <span className="select-filter_counter" title={title}>
      {`+ ${items.length}`}
    </span>
  );
};

export const MultiValue = ({ ...props }: MultiValueProps<SelectOptions>) => {
  const { index, getValue } = props;
  const maxToShow = 4;
  const overflow = getValue()
    .slice(maxToShow)
    .map((x: SelectOptions) => x.label);
  if (index < maxToShow) return <components.MultiValue {...props} />;
  return index === maxToShow ? <MoreSelectedBadge items={overflow} /> : null;
};

const { Option } = components;
export const IconOption = (props: OptionProps<SelectOptions>) => {
  const isSelected = props.isSelected;
  return (
    <Option {...props}>
      <div className="vtmn-flex vtmn-justify-between">
        {props.data.label}
        {isSelected && <VpIcon name="check" />}
      </div>
    </Option>
  );
};
